import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-articleship-end-report',
  templateUrl: './articleship-end-report.component.html',
  styleUrls: ['./articleship-end-report.component.css']
})
export class ArticleshipEndReportComponent implements OnInit {

  articleshipEndReport=[];

  constructor(private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; 
    const currentYear = currentDate.getFullYear();
    this.getArticleshipEndDetails(currentMonth,currentYear);
  }

   getArticleshipEndDetails(month: number, year: number) {
    this.masterDataService
        .getArticleshipEndDetails(month,year)
        .subscribe((res:any) => {
          this.articleshipEndReport = res;
        });
  }

}
